import SessionUtils from "@/utility/SessionUtils";
import StorageUtils from "@/utility/StorageUtils";
import { getActiveShop } from "@/constants/utility";
import { useState, useEffect, useRef } from "react";

export const useEmployeeMode = () => {
  const savedEmployee = SessionUtils.getItem("rs_employee");
  const shop = getActiveShop(StorageUtils.getItem(StorageUtils.storeKey));
  const [employee, setemployee] = useState(() => savedEmployee);


  const userRef = useRef();

  useEffect(() => {
    if (!userRef.current && savedEmployee?._id) {
      userRef.current = savedEmployee?._id;
      setemployee((s) => savedEmployee);
    }
  }, [savedEmployee]);

  const signoutEmployee = () => {
    SessionUtils.removeItem("rs_employee");
  };

  useEffect(() => {
    return idleLogout(() => {
      signoutEmployee();
      window.location.reload();
    }, getPinTimeout(employee, shop) * 60 * 1000);
  }, []);

  return {
    employee,
    signoutEmployee,
  };
};

function getPinTimeout(employee, shop) {
  if ( employee === null) {
    if (shop === null) {
      return 20;
    }
    return shop.pinTimeout;
  } else if (employee.pinTimeout == null) {
    return shop.pinTimeout;
  } else {
    if (employee.pinTimeout < 1){
      return 1;
    }
    return employee.pinTimeout; 
  }
}

function idleLogout(task, time = 1200000) {
  let t;

  window.addEventListener("load", resetTimer, true); // improved; see comments
  window.addEventListener("mousemove", resetTimer, true); /// catches touchscreen presses as well
  window.addEventListener("mousedown", resetTimer, true); // // catches touchscreen presses as well
  window.addEventListener("touchstart", resetTimer, true); // catches touchscreen swipes as well
  window.addEventListener("touchmove", resetTimer, true); // required by some devices
  window.addEventListener("click", resetTimer, true); // catches touchpad clicks as well
  window.addEventListener("keydown", resetTimer, true); // catches touchpad clicks as well
  window.addEventListener("scroll", resetTimer, true); // improved; see comments

  function clearEventListener() {
    clearTimeout(t);
    window.removeEventListener("load", resetTimer, true); // improved; see comments
    window.removeEventListener("mousemove", resetTimer, true); /// catches touchscreen presses as well
    window.removeEventListener("mousedown", resetTimer, true); // // catches touchscreen presses as well
    window.removeEventListener("touchstart", resetTimer, true); // catches touchscreen swipes as well
    window.removeEventListener("touchmove", resetTimer, true); // required by some devices
    window.removeEventListener("click", resetTimer, true); // catches touchpad clicks as well
    window.removeEventListener("keydown", resetTimer, true); // catches touchpad clicks as well
    window.removeEventListener("scroll", resetTimer, true); // improved; see comments
  }

  function resetTimer() {
    clearTimeout(t);
    t = setTimeout(task, time); // time is in milliseconds
  }

  return clearEventListener;
}
